import React from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SectionReveal, StaggerWords } from "../components/Motion";
import { useT } from "../i18n/LanguageContext";

export default function StudioPage() {
  const { t } = useT();
  const ref = React.useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], ["0%", "-15%"]);

  return (
    <div className="pt-32 md:pt-40 pb-24 md:pb-32 bg-[#EFECE6]" data-testid="studio-page" ref={ref}>
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 mb-20 md:mb-32">
          <p className="col-span-12 md:col-span-3 text-[11px] uppercase tracking-[0.28em] text-[#4c535a]">{t.studio.eyebrow}</p>
          <h1 className="col-span-12 md:col-span-9 type-display text-[#4c535a]">
            <StaggerWords text={t.studio.title_1} />
            <br />
            <StaggerWords text={t.studio.title_2} delay={0.15} className="italic font-light" />
          </h1>
        </div>

        <div className="grid grid-cols-12 gap-5 md:gap-12 mb-24 md:mb-40">
          <div className="col-span-12 md:col-span-5">
            <motion.div style={{ y: y1 }}>
              <img
                src="https://customer-assets-agu9un31.emergentagent.net/job_wardrobe-studio-58/artifacts/ywpy34sx_ChatGPT%20Image%20Jul%2021%2C%202026%2C%2007_54_34%20PM.png"
                alt="Founder of Ordo Rex Studio"
                className="w-full h-auto"
              />
            </motion.div>
          </div>

          <div className="col-span-12 md:col-span-6 md:col-start-7">
            <SectionReveal delay={0.2}>
              <div className="space-y-6 font-sans type-body text-[#4c535a]/85 max-w-[54ch]">
                {t.studio.body.map((p, i) => (
                  <p key={i}>
                    {p.split(/(Ordo Rex Studio)/g).map((part, j) =>
                      part === "Ordo Rex Studio" ? <strong key={j} className="font-semibold text-[#4c535a]">{part}</strong> : part
                    )}
                  </p>
                ))}
              </div>
            </SectionReveal>

            <SectionReveal delay={0.3}>
              <p className="mt-10 italic font-light font-serif text-sm md:text-base text-[#4c535a]">— {t.studio.lead_italic}</p>
            </SectionReveal>
          </div>
        </div>

        <div className="border-t border-[#4c535a]/25 pt-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <h3 className="type-h1 text-[#4c535a]">
            {t.studio.ready}
          </h3>
          <Link to="/enquiry" data-testid="studio-cta-enquire" className="group inline-flex items-center gap-3 px-6 py-4 bg-[#4c535a] text-[#EFECE6] text-[11px] uppercase tracking-[0.24em] hover:bg-[#3d434a] transition-colors duration-500 flex-none">
            {t.common.begin_enquiry}
            <ArrowRight className="w-4 h-4 transition-transform duration-500 group-hover:translate-x-1" strokeWidth={1.4} />
          </Link>
        </div>
      </div>
    </div>
  );
}
